import { render, staticRenderFns } from "./RequestPasswordReset.vue?vue&type=template&id=7b70945c&scoped=true&lang=pug&"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=ts&"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=ts&"
import style0 from "./RequestPasswordReset.vue?vue&type=style&index=0&id=7b70945c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b70945c",
  null
  
)

export default component.exports